/* eslint-disable no-console */
import { call, put, takeLatest } from 'redux-saga/effects';
import { actions } from '../redux/Slices/CommPreferencesSlice';
import networkConfig from '../network/config';
import { setErrorCode } from '../redux/Actions/ErrorAction';
import invokeApi from '../network/index';
import { StatusCodes } from 'http-status-codes';
export const PREFERENCES_UPDATE_FAILED = 'Could not update the communication preferences';
const isOK = (status) => status === StatusCodes.OK || status === StatusCodes.CREATED || status === StatusCodes.ACCEPTED;
export function* checkHttpErrors(status, response) {
    if (!isOK(status)) {
        yield put(setErrorCode(status));
        throw new Error(response.message);
    }
}
export function* fetchPreferences(request) {
    try {
        const params = { queryProps: request?.payload?.params };
        const { response, status } = yield call(invokeApi, networkConfig.fetchCommPreferences, params);
        yield* checkHttpErrors(status, response);
        yield put(actions.fetchSuccess({
            data: response,
        }));
    }
    catch (error) {
        yield put(actions.fetchFailed({
            message: error.message,
        }));
    }
}
export function* updatePreferences(request) {
    try {
        const params = { queryProps: request?.payload?.params };
        const data = request?.payload?.data;
        const { response, status } = yield call(invokeApi, networkConfig.updateCommPreferences, params, {}, data);
        yield* checkHttpErrors(status, response);
        console.log(response);
        if (response === false) {
            yield put(actions.updateFailed({
                message: PREFERENCES_UPDATE_FAILED,
            }));
            return;
        }
        yield put(actions.updateSuccess({
            data: data,
        }));
    }
    catch (error) {
        yield put(actions.updateFailed({
            message: error.message,
        }));
    }
}
export function* fetchCommPreferencesSaga() {
    yield takeLatest(actions.fetch.type, fetchPreferences);
}
export function* updateCommPreferencesSaga() {
    yield takeLatest(actions.update.type, updatePreferences);
}
